angular.module('gym.users', []).config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('gym.users', {
    url: '/users?page&sort',
    controller: 'UsersCtrl'
  }).state('gym.users-edit', {
    url: '/users/:userId/edit',
    controller: ["$scope", "GTMService", "AdminUserService", "MasqueradingService", function($scope, GTMService, AdminUserService, MasqueradingService) {
      GTMService.trackPage('Users Edit');
      $scope.adminHasPermission = AdminUserService.has;
      return $scope.canChangeEmail = MasqueradingService.isMasquerading() && $scope.adminHasPermission('admin_change_user_email');
    }]
  }).state('gym.users.show', {
    url: '/:userId'
  }).state('gym.user-invite', {
    url: '/invitations/new',
    controller: 'InviteUserCtrl'
  }).state('gym.edit-user-invite', {
    url: '/invitations',
    controller: 'InviteUserCtrl'
  });
}]);
